import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import DropDownSelect from '../dropDownSelect';
import DropDownSearchable from '../dropDownSearchable';

import {
    isNullCheckOperator,
    isRelativeDateOperator,
} from '../../utilities/datagrid';
import RelativeDateInput from './relativeDateInput';
import './datagridSearchForm.css';

const OperatorDropDown = ({ selected, options, onChange }) => (
    <div style={{ minWidth: '130px' }}>
        <DropDownSelect
            options={options}
            selected={selected}
            onSelect={onChange}
            buttonStyling={{
                height: '35px',
            }}
            buttonLabelStyling={{
                alignItems: 'center',
                justifyContent: 'space-around',
            }}
        />
    </div>
);

const NumberOperatorOptions = [
    '<',
    '<=',
    '>',
    '>=',
    '=',
    '!=',
    'empty',
    'not empty',
];
const DateOperatorOptions = [
    ...NumberOperatorOptions,
    '<= relative',
    '>= relative',
];

const isEnumOperator = (op) =>
    ['in', 'not in', 'empty', 'not empty'].includes(op);

const FilterValueInput = ({ definition, value, onFieldChange }) => {
    const handleInputChange = (e) => {
        onFieldChange({
            id: value.id,
            fieldName: `${definition.category}.${definition.name}`,
            operator: value.operator,
            value: e.target.value,
        });
    };

    const handleOperatorChange = (v) => {
        const alwaysClear =
      (v === 'contains' && isEnumOperator(value?.operator)) ||
      (isEnumOperator(v) && value?.operator == 'contains');
        const fieldValue =
      isNullCheckOperator(v) || alwaysClear ? '' : value?.value;
        onFieldChange({
            id: value.id,
            fieldName: `${definition.category}.${definition.name}`,
            operator: v,
            value: fieldValue,
        });
    };

    const handleValueChange = (v) => {
        onFieldChange({
            id: value.id,
            fieldName: `${definition.category}.${definition.name}`,
            operator: value.operator,
            value: v,
        });
    };

    const handleMultiSelectChange = (selections) => {
        const selected = selections.map((s) => s.value);
        onFieldChange({
            id: value.id,
            fieldName: `${definition.category}.${definition.name}`,
            operator: value.operator,
            value: selected,
        });
    };

    const handleRelativeDateChange = (units, nUnits) => {
        onFieldChange({
            id: value.id,
            fieldName: `${definition.category}.${definition.name}`,
            operator: value.operator,
            value: {
                units,
                nUnits,
            },
        });
    };

    const getInputField = () => {
        let options;
        let defaultValue;
        switch (definition.type) {
        case 'date':
            return (
                <>
                    <OperatorDropDown
                        options={DateOperatorOptions}
                        selected={value.operator}
                        onChange={handleOperatorChange}
                    />
                    {isRelativeDateOperator(value.operator) ? (
                        <RelativeDateInput
                            value={value.value}
                            onChange={handleRelativeDateChange}
                        />
                    ) : (
                        !isNullCheckOperator(value.operator) && (
                            <input
                                type="date"
                                autoFocus
                                value={value.value.toString()}
                                onChange={handleInputChange}
                                style={{ width: '200px' }}
                            />
                        )
                    )}
                </>
            );
        case 'number':
            return (
                <>
                    <OperatorDropDown
                        options={NumberOperatorOptions}
                        selected={value.operator}
                        onChange={handleOperatorChange}
                    />
                    {!isNullCheckOperator(value.operator) && (
                        <input
                            type="number"
                            autoFocus
                            value={value.value.toString()}
                            onChange={handleInputChange}
                            style={{
                                marginRight: 0,
                                marginInlineEndWidth: '100%',
                                textAlign: 'right',
                            }}
                        />
                    )}
                </>
            );
        case 'boolean':
            return (
                <>
                    <OperatorDropDown
                        options={['=', 'empty', 'not empty']}
                        selected={value.operator}
                        onChange={handleOperatorChange}
                    />
                    {!isNullCheckOperator(value.operator) && (
                        <DropDownSelect
                            options={['true', 'false']}
                            selected={value.value.toString()}
                            onSelect={handleValueChange}
                            label="Select"
                        />
                    )}
                </>
            );
        case 'enum':
            options = definition.values.map((v) => ({ value: v, label: v }));
            defaultValue = value.value || null;
            if (value.operator && value.operator !== 'contains' && value?.value) {
                defaultValue = value.value.map((v) => ({ value: v, label: v }));
            }
            return (
                <>
                    <OperatorDropDown
                        options={['in', 'not in', 'empty', 'not empty', 'contains']}
                        selected={value.operator}
                        onChange={handleOperatorChange}
                    />
                    {isNullCheckOperator(value.operator) ? null : value.operator ===
              'contains' ? (
                            <input
                                value={value.value.toString()}
                                onChange={handleInputChange}
                                autoFocus
                                className="searchFormStringInput searchFormInput"
                            />
                        ) : (
                            <div style={{ minWidth: '200px' }}>
                                <DropDownSearchable
                                    options={options}
                                    isMulti={true}
                                    onSelect={handleMultiSelectChange}
                                    value={defaultValue}
                                />
                            </div>
                        )}
                </>
            );
        case 'currency':
            return (
                <>
                    <OperatorDropDown
                        options={NumberOperatorOptions}
                        selected={value.operator}
                        onChange={handleOperatorChange}
                    />
                    {!isNullCheckOperator(value.operator) && (
                        <CurrencyInput
                            size="12"
                            value={value.value}
                            id={`${definition.category}-${definition.name}`}
                            name={`${definition.category}-${definition.name}`}
                            allowDecimals={true}
                            allowNegativeValue={false}
                            onValueChange={handleValueChange}
                            prefix="$"
                            autoFocus
                            className="searchFormCurrencyInput searchFormInput"
                        />
                    )}
                </>
            );
        case 'string':
        default:
            return (
                <>
                    <OperatorDropDown
                        options={['=', 'contains', 'empty', 'not empty']}
                        selected={value.operator}
                        onChange={handleOperatorChange}
                    />
                    {!isNullCheckOperator(value.operator) && (
                        <input
                            value={value.value.toString()}
                            onChange={handleInputChange}
                            autoFocus
                            className="searchFormStringInput searchFormInput"
                        />
                    )}
                </>
            );
        }
    };
    return (
        <div className="d-flex gap-1 align-items-center" style={{ flex: '1' }}>
            {getInputField()}
        </div>
    );
};

export default FilterValueInput;
